import { render, staticRenderFns } from "./traveler.vue?vue&type=template&id=6b4de39a&scoped=true"
import script from "./traveler.vue?vue&type=script&lang=js"
export * from "./traveler.vue?vue&type=script&lang=js"
import style0 from "./traveler.vue?vue&type=style&index=0&id=6b4de39a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4de39a",
  null
  
)

export default component.exports